// removed by extract-text-webpack-plugin
module.exports = {"Icon":"Icon__Icon__1blAf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Icon/Icon.css
// module id = 281
// module chunks = 0